import { useEffect } from 'react'

import { useAlertDialog } from '../../../hooks/use-alert-dialog'
import { type SetAlertsCardProps } from './set-alerts-card'

export type UseSetAlertsCardParams = Pick<SetAlertsCardProps, 'defaultValues' | 'onValueChange' | 'onError'>

export const useSetAlertsCard = ({ defaultValues, onValueChange, onError }: UseSetAlertsCardParams) => {
  const { form, formErrors, values, markAlertTypeError, markAlertDateError, markCountError, markUnitError } =
    useAlertDialog({
      defaultValues,
    })

  /**
   * lift values up to the parent component when values change
   */
  useEffect(() => {
    onValueChange(values)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.alertType, values.alertDate, values.notificationSettings])

  /**
   * lift error state up to the parent component when errors change
   */
  useEffect(() => {
    onError(form.formState.errors)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.formState.errors.alertType, form.formState.errors.alertDate, form.formState.errors.notificationSettings])

  return {
    form,
    formErrors,
    markAlertTypeError,
    markAlertDateError,
    markCountError,
    markUnitError,
  }
}
